import { Backdrop, Fade, Grid, Modal, makeStyles } from '@material-ui/core';
import { BASIC_IMAGE_UPLOAD, DELETE_IMAGE_LINK } from 'configurations/configApi';
import React, { useState } from 'react';
import LoadingOverlay from 'components/overlays/LoadingOverlay';
import ImageUpload from './ImageUpload';
import { apiDelete, apiPost } from 'apiActions/action';
import { handleError } from 'views/FunctionalComponents/ErrorHandle';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));


const NumberOfItems = 8;

function ProductImagePanel(props) {
  const {
    productId,
    images,
    onChangeImages
  } = props;

  const classes = useStyles();

  const [modal, setModal] = useState({
    open: false,
    selectedItem: null,
  });
  const [loading, setLoading] = useState(false);
  const [imageItems, setImageItems] = useState({});

  const handleUpload = placement => {
    if (imageItems && imageItems[placement]?.image) {
      handleImageUpload(placement);
    } else {
      setModal({
        open: true,
        selectedItem: placement,
      });
    }
  };

  const handleCloseModal = () => {
    setModal({
      open: false,
      selectedItem: null,
    });
  };

  const handleImageUpload = (placement) => {
    const selectedItem = imageItems[placement];

    if (!selectedItem || !selectedItem.image) {
      return;
    }

    const selectedImage = selectedItem.image;
    const updateBackground = selectedItem.updateBackground;
    const resize = selectedItem.resize;

    setLoading(true);
    const formData = new FormData();
    if (productId !== undefined) {
      formData.append("product_id", productId);
    }
    formData.append('placements', [placement]);
    formData.append('images', selectedImage, selectedImage.name);
    formData.append('update_background', updateBackground);
    formData.append('resize', resize);

    apiPost(BASIC_IMAGE_UPLOAD, formData, ({ status, response }) => {
      if (status) {
        handleCloseModal();
        setLoading(false);
        const newImages = response.data?.images;
        if (newImages && newImages.length) {
          const newImage = newImages[0];
          const originImage = images.find((image) => image.placement_name === newImage.placement_name);
          let newProductImages = images.slice();
          if (originImage) {
            newProductImages = images.map(productImage =>
              productImage.placement_name === newImage.placement_name ? newImage : productImage
            );
          } else {
            newProductImages.push(newImage);
          }

          onChangeImages(newProductImages);
          setImageItems((v) => ({
            ...v,
            [placement]: {
              image: null,
              updateBackground: false,
              resize: false,
            }
          }));
        }
      } else {
        setLoading(false);
        if (
          response.response &&
          response.response.status &&
          response.response.status === 401
        ) {
          handleError(response.response);
        } else {
          console.log(response.response.status);
        }
      }
    });
  };

  const handleClearImage = (title) => {
    let image = images.find(
      item => item.placement_name === title
    );
    if (image) {
      setLoading(true);
      apiDelete(
        `${DELETE_IMAGE_LINK}${image.id}/`,
        'delete',
        ({ status, response }) => {
          if (status) {
            const newProductImages = images.filter(productImage =>
              productImage.placement_name !== image.placement_name
            );
            onChangeImages(newProductImages);
            setLoading(false);
            // console.log("delete respose", response)
            // fetchMessage(true, response, 'delete');
          } else {
            setLoading(false);
            if (
              response.response &&
              response.response.status &&
              response.response.status === 401
            ) {
              handleError(response.response);
            } else {
              console.log(response.response.status);
            }
          }
        }
      );
    }
    setImageItems((v) => ({
      ...v,
      [title]: {
        image: null,
        updateBackground: false,
        resize: false
      }
    }));
  };

  const handleFileSelect = (placement, file) => {
    setImageItems((v) => ({
      ...v,
      [placement]: {
        ...v[placement],
        image: file,
      }
    }));
  };

  const handleChangeFileOption = ({placement, ...rest}) => {
    setImageItems((v) => ({
      ...v,
      [placement]: {
        ...v[placement],
        ...rest,
      }
    }));
  };

  return (
    <div className="infoBox">
      <LoadingOverlay showOverlay={loading} />
      <h5>
        <i className="fa fa-images" /> Images
      </h5>
      <div className="imageUpload">
        <Grid container spacing={2}>
          {Array.from({ length: NumberOfItems }).map((_, index) => {
            const _title = `ITEMIMAGEURL${index + 1}`;
            const _image = images.find((image) => image?.placement_name === _title);
            const imageItem = imageItems[_title];
            return (
              <Grid item xs={6} key={index} className="ImagUploadBox">
                <ImageUpload
                  isEdit={!!productId}
                  title={_title}
                  url={_image?.url}
                  checkUpdateBackground={imageItem?.updateBackground}
                  checkResize={imageItem?.resize}
                  onFileSelect={handleFileSelect}
                  onChangeCheckBox={handleChangeFileOption}
                  onUpload={() => handleUpload(_title)}
                  onClear={() => handleClearImage(_title)}
                />
              </Grid>
            )
          })}
        </Grid>
      </div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className="imageUploadPop"
        open={modal.open}
        onClose={handleCloseModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
      >
        <Fade in={modal.open}>
          <div className={classes.paper}>
            <h5 id="transition-modal-title">
              Import New Image For {modal.selectedItem}
            </h5>
            <span
              className="close"
              onClick={handleCloseModal}
            >
              <i className="fa fa-times" />
            </span>
            <input
              type="file"
              id="myFile"
              name="selectedImage"
              onChange={(e) => handleFileSelect(modal.selectedItem, e.target.files[0])}
            />
            <button
              type="button"
              onClick={() => handleImageUpload(modal.selectedItem)}
            >
              Upload
            </button>
            <button
              type="button"
              onClick={handleCloseModal}
            >
              Close
            </button>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}

export default ProductImagePanel;
